import { customFetch, appendHeadersWithJSONContentType } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8UserProfileUpdate } from 'services/production/types';
import { getM8UserURL } from 'services/production/utils/getM8URL';

type Params = {
  userProfileUpdate: M8UserProfileUpdate;
};

export const updateQuestionnaireInfo = async (params: Params) => {
  const { userProfileUpdate } = params;

  const body = JSON.stringify(userProfileUpdate);

  const headers = new Headers();

  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(getM8UserURL('updateQuestionnaireInfo'), {
    method: 'POST',
    body,
    headers,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
